import { defineStore } from 'pinia';

export const useUiStore = defineStore('ui', {
  state: () => {
    return {
      hoveredMainNavigationItem: null as NavigationItem | null,
      timeout: null as NodeJS.Timeout | null,
    };
  },

  actions: {
    onItemHover(item: NavigationItem) {
      this.hoveredMainNavigationItem = item;
    },
    onSidebarEnter() {
      if (this.timeout !== null) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    },
    onSidebarLeave() {
      this.timeout = setTimeout(() => {
        this.hoveredMainNavigationItem = null;
        this.timeout = null;
      }, 10);
    },
  },
});
